import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { Observable, map, catchError, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class ClientExportService {
  private http = inject(HttpClient);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  exportProspects(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams();
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
   
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT_EXPORT.EXPORT_PROSPECTS
      .replace('{tenant_id}', tenantId.toString()),{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  exportActiveClients(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT_EXPORT.EXPORT_ACTIVE_CLIENTS
      .replace('{tenant_id}', tenantId.toString()),{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  exportExClients(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT_EXPORT.EXPORT_EX_CLIENTS
      .replace('{tenant_id}', tenantId.toString()),{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  exportIrregularClients(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT_EXPORT.EXPORT_CLIENTS_AT_RISK
      .replace('{tenant_id}', tenantId.toString()),{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  exportClientTrials(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT_EXPORT.EXPORT_TRIALS
      .replace('{tenant_id}', tenantId.toString()),{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

}

